
/*
 * @Author: Ning
 * @Date: ****** 13:23:08
 * @LastEditTime: 2020-09-09 14:38:05
 * @LastEditors: Ning
 * @Description: System Logs 日志
 * @Do not edit
 */

export const PAGE_NAME = "上海惠联办公设备有限公司";  //all title
export const PAGE_COMPANY = "上海惠联办公设备有限公司";
export const USERVALIDTIME = 30 * 60 * 1000;   //过期时间
export const sendNationCaptchaName = 'publicHousing_baoshan_captcha'; //拓希短信
export const companyInfo = {
    companyCode: '013',
    companyName: '上海惠联办公设备有限公司'
};
export const NODE_API = process.env.NODE_ENV == 'production' ? '/api' : "/api"

export const AppToken = 'yKqKxO59c5'
export const AppSecret = 'g8SzIXPkOm'
export const FILEACTIONURL = '/group1/upload' //上传文件的action(本地上传)